/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs */

const en_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy event from Group B to Group A`)
};

const fr_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l'événement du groupe B vers le groupe A`)
};

const de_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis von Gruppe B nach Gruppe A kopieren`)
};

const it_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia l'evento dal Gruppo B al Gruppo A`)
};

const ru_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирование события из группы B в группу A`)
};

const es_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento del Grupo B al Grupo A`)
};

const zh_cn2_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 B 组的事件复制到 A 组`)
};

const ja_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループBからグループAにイベントをコピー`)
};

const hi_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ग्रुप B से ग्रुप A में इवेंट कॉपी करें`)
};

const pt_pt2_compare_event_groups_copy_event_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar evento do Grupo B para o Grupo A`)
};

/**
* | output |
* | --- |
* | "Copy event from Group B to Group A" |
*
* @param {Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_event_b_to_a_title = /** @type {((inputs?: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "de") return de_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "it") return it_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "ru") return ru_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "es") return es_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "ja") return ja_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "hi") return hi_compare_event_groups_copy_event_b_to_a_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_copy_event_b_to_a_title(inputs)
	return en_compare_event_groups_copy_event_b_to_a_title(inputs)
});